const isValidNumber = value => {
  return typeof value === 'number' && !Number.isNaN(value);
};

export const getPackageAmount = value => {
  if (typeof value === 'string' || typeof value === 'number') {
    return getNormalizedNumber(parseFloat(value));
  }
  return '0.00';
};

export const getNormalizedNumber = value => {
  if (isValidNumber(value)) {
    return value.toFixed(2);
  }
  return '0.00';
};
